define((require) => {
    "use strict";

    const _                     = require("underscore");
    const {DateUtil}              = require("shared/util/DateUtil");
    const EventDispatcher       = require("shared/util/EventDispatcher");
    const EditorEventsConstants = require("shared/services/EditorEventsConstants");
    const LoggedInUserState     = require("shared/ui/user/LoggedInUserState");
    const Preconditions         = require("shared/util/Preconditions");

    /**
     * The singleton event bus used to track events in the editor and send events to Mix Panel
     *
     * <p>Events in this case are simple strings describing the user action. A general pattern for it is
     * [action]:[target] and must follow the format specified in EditorEventsConstants.</p>
     *
     * <p>If the event requires additional properties, pass them as a single object when triggering the event.
     * Only include primitives, as analytics engines do not necessarily support things like arrays, objects, etc.</p>
     *
     * @class EditorEvents
     * @constructor
     */
    const EditorEvents = EventDispatcher.extend({

        /**
         * Send event to MixPanel via Segment integration
         * @param {String} eventName The name of the event, built based on EventNames in EditorEventConstants, never null.
         * @param {Object} eventProperties The properties/payload to be sent to MixPanel. TriggerOrigin field is mandatory.
         */
        trigger(eventName, eventProperties) {
            Preconditions.checkArgument(eventName);
            Preconditions.checkArgument(eventProperties);

            Preconditions.checkState(EditorEventsConstants.checkEvent(eventName), "Missing Event name from EditorEventConstants list");
            // Mandatory field
            Preconditions.checkState(!_.isUndefined(eventProperties.triggerOrigin), "Missing triggerOrigin property");

            eventProperties.timestamp = DateUtil.now();
            eventProperties.location = LoggedInUserState.get("location");

            // Remove null/undefined properties
            _.each(eventProperties, (eventProperty, key) => {
                if (_.isNull(eventProperty) || _.isUndefined(eventProperty)) {
                    delete eventProperties[key];
                }
            });

            this.__super();
        },

        constants: EditorEventsConstants.EventNames
    });

    // Singleton
    return new EditorEvents();
});



// WEBPACK FOOTER //
// ./src/shared/services/EditorEvents.js